import React from 'react';
import PropTypes from 'prop-types';

import { IntlProvider, FormattedMessage } from 'react-intl';
import Filter from './Filter';
import ActivityList from './ActivityList';
import IntentSelect from './IntentSelect';

import Config from '../utils/config';
import url from '../utils/url';
import filterUtil from '../utils/filter';

import { getCurrentTranslation } from '../utils/translations.js';
import {Button} from "react-bootstrap";
import premium from "../../images-cp/badge-premium_color.svg";

class FilteredActivityList extends React.Component {

    gradeTypes = {
        "cizi-jazyky": "languages"
    };

    constructor(props) {
        super(props);

        this.onNavigateBack = this.onNavigateBack.bind(this);
        this.onFilterChoice = this.onFilterChoice.bind(this);
        this.onIntentChoice = this.onIntentChoice.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.onScroll = this.onScroll.bind(this);

        const newUrlChunks = url.extractFiltersFromUrl(window.location.pathname, Config.get('filterProfileUrlPart'));
        let newGradeType = null;
        if (this.gradeTypes[newUrlChunks[0]]) {
            newGradeType = this.gradeTypes[newUrlChunks[0]];
        }

        const query = new URLSearchParams(window.location.search);

        this.state = {
            urlFilterChunks: newUrlChunks,
            filters: {},
            activities: [],
            activityIntents: [],
            recommendationAcitivities: [],
            bannerPublication: null,
            invalidState: false,
            loading: true,
            colourTheme: null,
            recap: /recap=true/.test(window.location.search),
            gradeType: newGradeType,
            intentKey: query.get('type') || '',
            page: parseInt(query.get('page')) || 1,
            userHasPremium: false,
            onlyContentPack: query.get('onlyContentPack') === 'true',
        };
    }

    componentDidMount() {
        window.onpopstate = this.onNavigateBack;

        this.fetchActivities(this.state.urlFilterChunks);
    }

    componentDidUpdate() {
        if (typeof window.repositionFilter === 'function') {
            window.repositionFilter();
        }
    }

    componentWillUnmount() {
        window.onpopstate = () => { }
    }

    fetchActivities(urlFilterChunks) {
        window.removeEventListener('scroll', this.onScroll);

        const isProfileDetail = Config.get('profileDetail') === 'true';
        const code = isProfileDetail ? (new URLSearchParams(window.location.search)).get('query') : '';
        const isCode = isProfileDetail && /^\d{3}-\d{3}$/.test(code);

        const urlFilters = url.composeFilterUrl(Config.get('activityFilterUrl'), urlFilterChunks, this.state.recap, 1, undefined, isCode ? [`kod=${code}`] : [], this.state.onlyContentPack);

        this.setState({
            loading: true,
        });

        fetch(urlFilters)
            .then((response) => {
                return response.json();
            })
            .then((responseJson) => {
                this.setState({
                    activities: responseJson.activities && responseJson.activities.items,
                    activityIntents: responseJson.activities && responseJson.activities.intents,
                    recommendationAcitivities: responseJson.recommendationAcitivities,
                    bannerPublication: responseJson.bannerPublication,
                    filters: responseJson.filter && responseJson.filter.steps,
                    invalidState: responseJson.error,
                    colourTheme: responseJson.colourTheme,
                    loading: false,
                    userHasPremium: responseJson.userHasPremium,
                    userIsLoggedIn: responseJson.userIsLoggedIn,
                });

                if (typeof window.repositionFilter === 'function') {
                    window.repositionFilter();
                }
                if (typeof window.restoreScroll === 'function') {
                    //window.restoreScroll();
                }

                window.addEventListener('scroll', this.onScroll);
            });
    }

    onNavigateBack(e) {
        if (history.state &&
            history.state.filter &&
            history.state.filter.changedFilterKey &&
            history.state.filter.newLabelId &&
            e.explicitOriginalTarget instanceof Window
        ) {
            const { changedFilterKey, newLabelId } = history.state.filter;
            this.onFilterChoice(changedFilterKey, newLabelId, false);
        }
    }

    onFilterChoice(changedFilterKey, newLabelId, pushHistory = true) {
        const { filters, urlFilterChunks } = this.state;
        const filtersUrlChunks = [];

        for (const filterKey in filters) {
            const filter = filters[filterKey];
            const isFilterChanged = filterKey === changedFilterKey;

            const filterSelected =
                (isFilterChanged && newLabelId && filterUtil.findFilterByLabelId(filter.items, newLabelId)) ||
                (filter.selected && filterUtil.findFilterByLabelId(filter.items, filter.selected)) ||
                null;

            if (filterSelected) {
                filtersUrlChunks.push(filterSelected.slug);
            }

            if (isFilterChanged) {
                break;
            }
        }

        const newUrlChunks = [urlFilterChunks[0], urlFilterChunks[1]].concat(filtersUrlChunks);
        let newGradeType = null;
        if (this.gradeTypes[urlFilterChunks[0]]) {
            newGradeType = this.gradeTypes[urlFilterChunks[0]];
        }
        this.setState({
            urlFilterChunks: newUrlChunks,
            gradeType: newGradeType,
        });

        this.fetchActivities(newUrlChunks);

        const newUrl = `${url.composeProfileUrl(newUrlChunks, this.state.recap, this.state.page, this.state.intentKey)}`;
        if (newUrl && pushHistory) {
            history.pushState({ filter: { changedFilterKey: changedFilterKey, newLabelId: newLabelId } }, '', newUrl);
        }

        window.collapseFilter();
        window.scrollToBeginning({ behavior: "smooth", block: "start", inline: "nearest" });
    }

    onIntentChoice(intentKey) {
        this.refreshStateAndURL({ intentKey });
    }

    onOnlyContentPackChange(onlyContentPack) {
        this.refreshStateAndURL({ onlyContentPack });
        window.setTimeout(() => {
            this.fetchActivities(this.state.urlFilterChunks);
        }, 200);
    }

    onPageChange(page) {
        this.refreshStateAndURL({ page });
    }

    onScroll() {
        if (window.saveScroll) {
            //window.saveScroll();
        }
    }

    refreshStateAndURL(stateObject) {
        this.setState(stateObject, () => {
            const newUrlChunks = url.extractFiltersFromUrl(window.location.pathname, Config.get('filterProfileUrlPart'));
            const newUrl = `${url.composeProfileUrl(newUrlChunks, this.state.recap, this.state.page, this.state.intentKey, this.state.onlyContentPack)}`;
            if (newUrl) {
                history.replaceState(stateObject, '', newUrl);
                //window.saveScroll();
            }
        });
    }

    render() {
        const { heading, urlback } = this.props;
        const locale = Config.get('locale');

        if (this.state.invalidState) {
            return (
                <IntlProvider messages={getCurrentTranslation(locale)} locale={locale} defaultLocale="cs">
                    <div className="container">
                        <div className="row">
                            <p style={{
                                textAlign: 'center',
                                width: '100%',
                                paddingTop: '2em',
                                fontSize: '2em',
                                fontWeight: 'bold',
                            }}>
                                <FormattedMessage
                                    id='filter_activity_invalid_general_filter_combination'
                                    defaultMessage='Tato kombinace filtrů není platná. Zvolte prosím'
                                />
                                &nbsp;
                                <a href={Config.get('profileOverviewUrl')}>
                                    <FormattedMessage id='filter_activity_another_subject' defaultMessage='jiný předmět' />
                                </a>.</p>
                        </div>
                    </div>
                </IntlProvider>
            );
        }

        return (
            <IntlProvider messages={getCurrentTranslation(locale)} locale={locale} defaultLocale="cs">
                <React.Fragment>
                    <div className="profile-head fixed-behind">
                        <div className="profile-heading">
                            <a href={urlback} className="back">
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                                    <g id="Back" transform="translate(0 -25)">
                                        <circle id="Ellipse_593" data-name="Ellipse 593" cx="15" cy="15" r="15" transform="translate(0 25)" fill="#3a3a3a" />
                                        <g id="Arrow_Go" data-name="Arrow Go" transform="translate(17 45) rotate(180)">
                                            <path id="Path_4663" data-name="Path 4663" d="M4,0,0,5l4,5" transform="translate(4 10) rotate(180)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2" />
                                        </g>
                                    </g>
                                </svg>
                            </a>
                            <h1 className="text-left mt-0">{heading}</h1>
                            <div className="mt-3">
                                <Button variant={this.state.onlyContentPack ? 'outline-dark' : 'dark'} className="rounded-20 py-1 me-3" onClick={() => this.onOnlyContentPackChange(false)}>
                                    <FormattedMessage id='filter_activity_filter_button_all' defaultMessage='Všechna cvičení' />
                                </Button>

                                <Button variant={this.state.onlyContentPack ? 'dark' : 'outline-dark'} className="rounded-20 py-1" onClick={() => this.onOnlyContentPackChange(true)}>
                                    {premium && <img src={premium} alt={'Premium'} width={25} height={25} className="vertical-middle pe-2" />}
                                    <FormattedMessage id='filter_activity_filter_button_all' defaultMessage='Můj premiový obsah' />
                                </Button>
                            </div>
                        </div>

                        <IntentSelect choiceCallback={this.onIntentChoice} activityIntents={this.state.activityIntents} selectedIntent={this.state.intentKey} />
                    </div>
                    <ActivityList
                        activities={this.state.activities}
                        loading={this.state.loading}
                        colourTheme={this.state.colourTheme}
                        intentKey={this.state.intentKey}
                        pageChangeCallback={this.onPageChange}
                        page={this.state.page}
                        bannerPublication={this.state.bannerPublication?.name ? this.state.bannerPublication : null}
                        userHasPremium={this.state.userHasPremium}
                        onlyContentPack={this.state.onlyContentPack}
                        userIsLoggedIn={this.state.userIsLoggedIn}
                    />
                    <Filter filters={this.state.filters} colourTheme={this.state.colourTheme} recommendationAcitivities={this.state.recommendationAcitivities} choiceCallback={this.onFilterChoice} gradeType={this.state.gradeType} />
                </React.Fragment>
            </IntlProvider>
        );
    }
}

FilteredActivityList.propTypes = {
    filters: PropTypes.arrayOf(PropTypes.string),
    heading: PropTypes.string.isRequired,
    urlback: PropTypes.string.isRequired,
    userHasPremium: PropTypes.bool,
    userIsLoggedIn: PropTypes.bool,
};

export default FilteredActivityList;
